import { NewTag } from 'shared/types/tag';

import { newTagConverter } from './converters/tag';
import { addDocumentWithOwnerRole, CollectionOptions } from './helpers';

export const createTag = async (tag: NewTag) =>
  addDocumentWithOwnerRole(CollectionOptions.Tags, newTagConverter(tag));
